import styled from 'styled-components'

export const Categorie=styled.div`
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%);
    border-radius: 11px;
    position: relative;
    margin-top: 20px;
    img{
        width: 100%;
        height: 130px;
        border-radius: 11px; 
    }
    :hover >div{
        transform: scale(1);
    }
`;
export const  Overley=styled.div`
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 11px;
    background-color: #00b06acf;
    display: flex;
    justify-content: center;
    align-items: center;
    h6{
        font-size: 22px;
        font-weight: 700;
        color: white;
        text-transform: capitalize;
        cursor: pointer;
    :hover{
        text-decoration: underline;
    }
    }
`;

